import React from 'react';
import { toFlag } from 'pano-utils';
import type { CFNextScene, CFPrevScene } from '@types';
import { Collapse } from '@components/Collapse';
import { Dropdown } from '@components/Dropdown';
import FeatureToggle from '@components/FeatureToggle';
import { useCustomFeature } from '../CustomFeatureContext';
import { switchTypeItems } from '../constants';

interface Props {
  reverse?: boolean;
}

function CNextSceneSetting({ reverse = false }: Props) {
  const { data, setData } = useCustomFeature<CFNextScene | CFPrevScene>();
  return (
    <Collapse title="场景切换效果">
      <Dropdown
        items={switchTypeItems}
        selected={data.animation ?? 0}
        onChange={(val) => {
          setData((draft) => {
            draft.animation = val;
          });
        }}
      />
      <FeatureToggle
        title="切换时跳过隐藏缩略图场景"
        isOn={!!data.skipThumbHidden}
        onToggle={(bool) => {
          setData((draft) => {
            draft.skipThumbHidden = toFlag(bool);
          });
        }}
      />
      <FeatureToggle
        title={reverse ? '切换至首场景不再切换' : '切换至最后场景不再切换'}
        isOn={!!data.stopInLast}
        onToggle={(bool) => {
          setData((draft) => {
            draft.stopInLast = toFlag(bool);
          });
        }}
      />
    </Collapse>
  );
}

export default CNextSceneSetting;
